export const eSimSaleType = {
  eSimOnly: 'ESIMONLY',
  simOnly: 'SIMONLY',
  mixed: 'MIXED',
};

export const CellularModeEnum = {
  ESIM: 'esim',
  ESIM_NIUD: 'esimNiud',
  SIM: 'sim',
  SIM_NIUD: 'simNiud',
};

//Array details [IsEsim,IsExistNumber]
export const CellularModeByArrayEnum = {
  ESIM: 'true,false',
  ESIM_NIUD: 'true,true',
  SIM: 'false,false',
  SIM_NIUD: 'false,true',
};
export const ButtonMode = {
  INITSTATE: 0,
  INSTALL_ESIM: 1,
  SHOW_NIUD: 2,
  INSTALL_SIM: 3,
};
